import { extend } from 'acorn-jsx-walk'
import { ancestor, base, simple } from 'acorn-walk'

import { replaceNode, t } from '../ast/utils'

import type { TransformOptions } from '../transform'
import type { AnyNode } from 'acorn'

extend(base)

export function extractClassNames(
  node: AnyNode,
  options: TransformOptions = {}
): string[] {
  const prefix = options.classNamePrefix
  const classNames: string[] = []
  simple(node, {
    JSXAttribute(node) {
      if (t.isJSXIdentifier(node.name) && node.name.name === 'className') {
        const extract = (string: string) => {
          string = string.trim()
          if (!string) return
          if (prefix) {
            string = string.replaceAll(
              /\b(\S+:)*(\S+)\b/g,
              (_, variant = '', name) => `${variant}${prefix}${name}`
            )
          }
          classNames.push(...string.split(/\s+/))
          if (prefix) return t.literal(string)
        }
        ancestor(node, {
          Literal(node, state, ancestors) {
            if (typeof node.value === 'string') {
              const newNode = extract(node.value)
              if (newNode) replaceNode(ancestors, newNode)
            }
          },
          Property(node) {
            if (t.isIdentifier(node.key)) {
              const newNode = extract(node.key.name)
              if (newNode) node.key = newNode
            } else if (
              t.isLiteral(node.key) &&
              typeof node.key.value === 'string'
            ) {
              const newNode = extract(node.key.value)
              if (newNode) node.key = newNode
            }
          }
        })
      }
    }
  })
  return [...new Set(classNames)].filter(Boolean).toSorted()
}
